// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__2A-Vm","content":"default_content__HaDTN","header":"default_header__j3kYB","cards":"default_cards__2Lg+q"};